import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { AlertService } from '@services/alert.service';
import { CanDeactivateComponent } from './can-deactivate.interface';

export const unsavedChangesGuard: CanDeactivateFn<CanDeactivateComponent> = async (component) => {
  const alertService = inject(AlertService);

  if (!component || typeof component.canDeactivate !== 'function') {
    return true;
  }

  const deactivate = await component.canDeactivate();

  if (deactivate) {
    return true;
  }

  return alertService.confirmUnsavedChanges(component.saveAndExit.bind(component));
};
